import React, { Component, PropTypes } from 'react'

/* Utilities */
import _ from 'lodash'

/* Custom Asset */
import Caret from 'assets/dropdown-caret.svg'

/* Widgets */
import MenuItem from './menu-item'

/* Styles */
import './menu.css'

/* Single Playlist List Item */
export default class Menu extends Component {

  getClassName() {
    const {
      className,
      align,
      scheme
    } = this.props
    let classNameArr = (className || "").split(' ')
    classNameArr.push('dropdown-menu', 'widget')
    switch (align) {
      case "left":
        classNameArr.push('align-left')
        break
      case "center":
        classNameArr.push('align-center')
        break
      case "right":
      default:
        classNameArr.push('align-right')
    }
    switch (scheme) {
      case "dark":
        classNameArr.push('dark-scheme')
        break
    }
    return  classNameArr.join(' ')
  }

  render() {
    const {
      onClose,
      items
    } = this.props

    return (
      <div className={ this.getClassName() }>
        <div className="icon-wrapper"><Caret/></div><ul className="menu">
          {
            _.map(items, (item, index) => {
              if (item.type === "seperator") return <hr key={ index }/>
              return (
                <MenuItem
                  {... item }
                  key={ index }
                  index={ index }
                  onClose={ onClose }
                />
              )
            })
          }
        </ul>
      </div>
    )
  }
}

Menu.propTypes = {
  align: PropTypes.string,
  scheme: PropTypes.string,
  items: PropTypes.array,
  onClose: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/app/widget/dropdown-button/menu.jsx